import './FancyInput.css';
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FancyInput({type="text", onChangeCallback = null, 
                                    onKeyupCallback = null, icon="fa-solid fa-circle-question", 
                                    label="Input", width=null}){
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState("");
    function onChange(event){
        if(onChangeCallback === null) return false;
        onChangeCallback(event);
    }

    function onKeyUp(event){
        setValue(event.currentTarget.value);
        if(onKeyupCallback === null) return false;
        onKeyupCallback(event);
    }


    return (
        <>
            <div className={"fancy-input " + (focused || value.length > 0 ? "focused" : "")}>
                <label className="fancy-input-label "
                    style={{width: width === null ? "max-content" : width + "px"}} 
                    for={(label)+"input"}><FontAwesomeIcon icon={icon} />{label}</label>
                <input name={(label)+"input"} type={type} onChange={onChange} onKeyUp={onKeyUp} 
                    onFocus={()=> setFocused(true)}
                    onBlur={()=> setFocused(false)}
                />
            </div>
        </>
    )
}